// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._3tck2GZp3Clq3J {\n  margin: 10px 0 0;\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n}\n._3mCshMVzhgOR-N {\n  margin: 0 4px 5px;\n}\n._22u_djpLmR3HFq {\n  border-radius: 3px;\n  color: #5e6c84;\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 20px;\n  padding: 8px;\n  text-align: center;\n}\n._22u_djpLmR3HFq:hover {\n  background-color: #DFE1E6;\n  color: #172b4d;\n}\n._2gwfLLU6Cvq_45 {\n  margin-right: 4px;\n}\n._28YDl7KmsvA86D {\n  border-radius: 3px;\n  display: inline-block;\n  padding: 5px 8px;\n  text-align: center;\n}\n._28YDl7KmsvA86D:hover {\n  background-color: #DFE1E6;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footerLinks": "_3tck2GZp3Clq3J",
	"footerMessage": "_3mCshMVzhgOR-N",
	"blogLink": "_22u_djpLmR3HFq",
	"blogIcon": "_2gwfLLU6Cvq_45",
	"socialMediaLink": "_28YDl7KmsvA86D"
};
export default ___CSS_LOADER_EXPORT___;
